// extracted by mini-css-extract-plugin
module.exports = {"container":"SubHeading_container__2L6d-","container--white":"SubHeading_container--white__3E5tZ"};